"use client";

import React, { useRef } from "react";
import { ViewportList } from "react-viewport-list";
import { SiteType } from "@/types";
import { Alert, AlertDescription, AlertTitle } from "@oreme/ui";
import { SiteListItem } from "@/components";
import { useSite } from "@/hooks";
import { useTranslations } from "next-intl";

type SiteListProps = {
  data: SiteType[];
};

function SiteList({ data }: Readonly<SiteListProps>) {
  const t = useTranslations("site.SiteList");
  const ref = useRef<HTMLDivElement | null>(null);
  const { site, setSite } = useSite();

  if (!data?.length) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center w-full h-full p-4">
        <Alert className="text-center border-0">
          <AlertTitle>{t("oops")}</AlertTitle>
          <AlertDescription className="text-muted-foreground">
            {t("notFound")}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  const handleClick = (newSite: SiteType) => {
    if (newSite !== site) setSite(newSite);
  };

  return (
    <div
      ref={ref}
      className="absolute inset-0 overflow-y-auto px-2 py-1 flex flex-col gap-1"
    >
      <ViewportList viewportRef={ref} items={data}>
        {(item) => (
          <SiteListItem
            key={item.site_id}
            site={item}
            active={item.site_id == site?.site_id}
            onClick={() => handleClick(item)}
          />
        )}
      </ViewportList>
    </div>
  );
}

export { SiteList };
